import { useElement } from './core/element.js';
import './ripple.js';
const name = 's-button';
const props = {
    disabled: false,
    type: 'filled'
};
const style = `
:host{
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  vertical-align: middle;
  border-radius: 20px;
  padding: 0 24px;
  height: 40px;
  text-transform: capitalize;
  position: relative;
  cursor: pointer;
  font-size: .875rem;
  font-weight: 500;
  flex-shrink: 0;
  white-space: nowrap;
  background: var(--s-color-primary, ${"#006782"});
  color: var(--s-color-on-primary, ${"#ffffff"});
  transition: box-shadow .1s ease-out;
  overflow: hidden;
}
:host([disabled=true]){
  pointer-events: none !important;
  background: color-mix(in srgb, var(--s-color-on-surface, ${"#191c1e"}) 12%, transparent) !important;
  color: color-mix(in srgb, var(--s-color-on-surface, ${"#191c1e"}) 38%, transparent) !important;
}
:host([type=elevated]){
  background: var(--s-color-surface-container-low, ${"#f2f4f5"});
  color: var(--s-color-primary, ${"#006782"});
  box-shadow: var(--s-elevation-level1, ${"0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)"});
}
:host([type=elevated][disabled=true]){
  box-shadow: none !important;
}
:host([type=filled-tonal]){
  background: var(--s-color-secondary-container, ${"#cfe6f1"});
  color: var(--s-color-on-secondary-container, ${"#071e26"});
}
:host([type=outlined]){
  border: solid 1px var(--s-color-outline, ${"#70787d"});
  background: none;
  color: var(--s-color-primary, ${"#006782"});
}
:host([type=outlined][disabled=true]){
  background: none !important;
  border-color: color-mix(in srgb, var(--s-color-on-surface, ${"#191c1e"}) 12%, transparent) !important;
}
:host([type=text]){
  background: none;
  color: var(--s-color-primary, ${"#006782"});
  padding: 0 16px;
}
:host([type=text][disabled=true]){
  background: none !important;
}
.ripple{
  border-radius: 0;
}
::slotted(*){
  fill: currentColor;
  color: currentColor;
  width: 18px;
  height: 18px;
}
::slotted(s-icon[slot=start]),
::slotted(svg[slot=start]){
  margin: 0 4px 0 -8px;
}
::slotted(s-icon[slot=end]),
::slotted(svg[slot=end]){
  margin: 0 -8px 0 4px;
}
::slotted(s-circular-progress[slot=start]){
  margin: 0 8px 0 -8px;
}
::slotted(s-circular-progress[slot=end]){
  margin: 0 -8px 0 8px;
}
:host([type=text]) ::slotted(s-icon[slot=start]),
:host([type=text]) ::slotted(svg[slot=start]){
  margin: 0 4px 0 -4px;
}
:host([type=text]) ::slotted(s-icon[slot=end]),
:host([type=text]) ::slotted(svg[slot=end]){
  margin: 0 -4px 0 4px;
}
:host([rippled]){
  box-shadow: var(--s-elevation-level1, ${"0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)"});
}
:host([type=elevated][rippled]){
  box-shadow: var(--s-elevation-level2, ${"0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12)"});
}
:host([type=filled-tonal][rippled]),
:host([type=outlined][rippled]),
:host([type=text][rippled]){
  box-shadow: none;
}
@media (pointer: fine){
  :host([type=elevated]:hover){
    box-shadow: var(--s-elevation-level2, ${"0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12)"});
  }
  :host(:hover){
    box-shadow: var(--s-elevation-level1, ${"0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)"});
  }
  :host([type=filled-tonal]:hover),
  :host([type=outlined]:hover),
  :host([type=text]:hover){
    box-shadow: none;
  }
}
`;
const template = `
<slot name="start"></slot>
<slot></slot>
<slot name="end"></slot>
<s-ripple class="ripple" attached="true" part="ripple"></s-ripple>
`;
export class Button extends useElement({ style, template, props, syncProps: true, }) {
}
Button.define(name);
